import * as actionTypes from "../actions/actionTypes";

export default function navPoint(state = {}, action) {
  switch (action.type) {
    case actionTypes.SET_NAV_POINT: {
      return { ...action.navPoint };
    }
    default:
      return state;
  }
}
